// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/assistenza/ticket',
    requestBody: null,
    response: '{ success: true, data: [{ id, tipo, priorita, stato, titolo, modulo, urlPagina, createdByName, createdAt, societa: { id, nome }, _count: { allegati, risposte } }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/assistenza/ticket',
    requestBody: 'FormData{ tipo, priorita, titolo, descrizione, modulo?, urlPagina?, societaId?, chatId?, allegati[]? }',
    response: '{ success: true, data: { id } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
